import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { axiosInstance } from '../../../network/apis';
import { DisplayErrors } from '../../../utils/DisplayErrors';
import { Logo } from '../../shared/LogoWithCompany';

export const AboutUs = () => {
  const [data, setData] = useState('');
  const { locale } = useIntl();
  const about = useRef();

  const getData = async () => {
    try {
      const res = await axiosInstance.get('/pages/about');
      setData(res.data.body[locale]);
    } catch (err) {
      DisplayErrors(err);
    }
  };

  useEffect(() => {
    getData();
  });

  useEffect(() => {
    about.current.innerHTML = data;
  }, [data]);

  return (
    <div className='mt-20 pb-20'>
      <div className='text-center'>
        <span className='bg-danger'>
          <Logo />
        </span>
      </div>
      <div ref={about} className='container mt-20 mb-20'></div>
    </div>
  );
};
